import { defineCoach } from '../../types';
import { PERMISSIONS, canAll } from '../tasks/access';

/** The person opens and awards an existing draft; the coach only observes. */
export const C03 = defineCoach({
  id: 'C03',
  version: 1,
  portal: 'tenant',
  titleKey: 'guidance.coaches.C03.title',
  summaryKey: 'guidance.coaches.C03.summary',
  eligible: (ctx) =>
    ctx.portal === 'tenant' &&
    canAll(ctx, PERMISSIONS.rfqView, PERMISSIONS.rfqManage, PERMISSIONS.rfqAward),
  steps: [
    {
      id: 'c03-welcome',
      kind: 'explain',
      page: 'tenant.sourcing',
      anchor: null,
      titleKey: 'guidance.coaches.C03.welcome.title',
      bodyKey: 'guidance.coaches.C03.welcome.body',
      route: 'tenant.sourcing',
    },
    {
      id: 'c03-open-draft',
      kind: 'await',
      page: 'tenant.sourcing',
      anchor: 'tenant.sourcing.queue',
      titleKey: 'guidance.coaches.C03.open-draft.title',
      bodyKey: 'guidance.coaches.C03.open-draft.body',
      until: { route: 'tenant.rfq', probe: { anchor: 'tenant.rfq.header', in: ['draft'] } },
    },
    {
      id: 'c03-requirement',
      kind: 'explain',
      page: 'tenant.rfq',
      anchor: 'tenant.rfq.draft-summary',
      titleKey: 'guidance.coaches.C03.requirement.title',
      bodyKey: 'guidance.coaches.C03.requirement.body',
    },
    {
      id: 'c03-invite',
      kind: 'explain',
      page: 'tenant.rfq',
      anchor: 'tenant.rfq.invite',
      titleKey: 'guidance.coaches.C03.invite.title',
      bodyKey: 'guidance.coaches.C03.invite.body',
    },
    {
      id: 'c03-publish-handoff',
      kind: 'handoff',
      page: 'tenant.rfq',
      anchor: 'tenant.rfq.open',
      titleKey: 'guidance.coaches.C03.publish-handoff.title',
      bodyKey: 'guidance.coaches.C03.publish-handoff.body',
      consequenceKey: 'guidance.coaches.C03.publish-handoff.consequence',
    },
    {
      id: 'c03-publish',
      kind: 'await',
      page: 'tenant.rfq',
      anchor: 'tenant.rfq.open',
      titleKey: 'guidance.coaches.C03.publish.title',
      bodyKey: 'guidance.coaches.C03.publish.body',
      disabledExplainKey: 'guidance.coaches.C03.publish.blocked',
      until: {
        outcome: 'rfq.opened',
        route: 'tenant.rfq',
        probe: { anchor: 'tenant.rfq.header', in: ['open'] },
      },
    },
    {
      id: 'c03-compare',
      kind: 'explain',
      page: 'tenant.rfq',
      anchor: 'tenant.rfq.comparison',
      titleKey: 'guidance.coaches.C03.compare.title',
      bodyKey: 'guidance.coaches.C03.compare.body',
    },
    {
      id: 'c03-award-handoff',
      kind: 'handoff',
      page: 'tenant.rfq',
      anchor: 'tenant.rfq.decision',
      titleKey: 'guidance.coaches.C03.award-handoff.title',
      bodyKey: 'guidance.coaches.C03.award-handoff.body',
      consequenceKey: 'guidance.coaches.C03.award-handoff.consequence',
    },
    {
      id: 'c03-award',
      kind: 'await',
      page: 'tenant.rfq',
      anchor: 'tenant.rfq.decision',
      titleKey: 'guidance.coaches.C03.award.title',
      bodyKey: 'guidance.coaches.C03.award.body',
      disabledExplainKey: 'guidance.coaches.C03.award.blocked',
      until: {
        outcome: 'rfq.awarded',
        route: 'tenant.rfq',
        probe: { anchor: 'tenant.rfq.header', in: ['awarded'] },
      },
    },
    {
      id: 'c03-result',
      kind: 'explain',
      page: 'tenant.rfq',
      anchor: 'tenant.rfq.header',
      titleKey: 'guidance.coaches.C03.result.title',
      bodyKey: 'guidance.coaches.C03.result.body',
    },
    {
      id: 'c03-finish',
      kind: 'finish',
      page: 'tenant.rfq',
      anchor: null,
      titleKey: 'guidance.coaches.C03.finish.title',
      bodyKey: 'guidance.coaches.C03.finish.body',
    },
  ],
});
